export const ENV = {
  BASE_PATH: process.env.REACT_APP_API_BASE_URL,
  PAYMENTS: process.env.REACT_APP_PAYMENTS,
  BASE_BOX: "http://www.colsubsidio.com",
  CHANNEL_ID: 10,
  OPERA_ID: 9,
  CREDIT_LEGACY_ID: 3,
  OBLIGATION_LEGACY_ID: 4,
  PATHS: {
    FRONT: process.env.REACT_APP_BASE_URL
  },
  TEXT: {
    PSE: "Pagos con PSE",
    TERMS_LABEL_PART1:"Al enviar la información autorizas: ",
    TERMS_LABEL_PART2:"la política de tratamiento de datos personales",
    TERMS_LABEL_PART3:" la autorización para la utilización de datos personales (PDF,105 KB)",
    TERMS_LABEL_PART4:" el aviso de privacidad (PDF,119 KB)",
    TERMS_LABEL_PART5:" el derecho a la intimidad de los consumidores (PDF,82.4 KB)",
    POLICY_URL:"https://www.colsubsidio.com/tratamiento-de-datos",
    AUTHORIZATION_URL:"https://www.colsubsidio.com/hubfs/7212050/documentos/colsubsidio/autorizacion-para-la-utilizacion-de-datos-personales-colsubsidio.pdf",
    PRIVACY_URL: "https://www.colsubsidio.com/hubfs/7212050/documentos/colsubsidio/aviso-de-privacidad-de-colsubsidio.pdf",
    RIGHT_URL: "https://www.colsubsidio.com/hubfs/documentos/colsubsidio/autorizacion-ley-2300-de-2023.pdf",
    ERROR_ALERT_DEBTS: "Los datos ingresados no presentan obligaciones asociadas. Intenta de nuevo con otros datos.",
    ERROR_ALERT_CREATE_PAY: "Tienes un proceso de pago pendiente. Termina de realizar el pago o intenta nuevamente dentro de 20 minutos.",
    ERROR_ALERT_VALIDATION: "Los datos ingresados no corresponden a personas afiliadas a Colsubsidio. Intenta de nuevo con otros datos.",
    ERROR_ALERT_SERVER: "Ha ocurrido un error en la validación del sistema. Por favor intenta nuevamente.",
    MSG_PAYMENT_PENDING: "El pago aún no aparece reflejado en nuestra plataforma, esto puede tardar unos minutos. Actualiza la página varias veces hasta ver la confirmación del pago.",
    MSG_PAYMENT_CANCELED: "Ha ocurrido un inconveniente con el pago y ha sido cancelado. Vuelve a intentar nuevamente.",
    MSG_PAYMENT_REJECTED: "Ha ocurrido un inconveniente con la plataforma y el pago ha sido rechazado. Vuelve a intentar nuevamente.",
    MSG_PAYMENT_TIME: "Tu pago se verá reflejado durante las próximas 24 horas.",
    MSG_LINK_SENT: "Link de pago enviado exitosamente.",
    BACK_ERROR_RESPONSE: "El documento ingresado no se encuentra afiliado a la caja. Intente nuevamente con otro documento"
  }
};
